import {Tabs} from "antd";
import SinglePageLayout from "../../../../layout/SinglePageLayout";
import Overview from "./Overview";
// import Dispatching from "./Dispatching";
// import Historisation from "./Historisation";

const GestionDesAttestations = () => {
    return (
        <SinglePageLayout>
            <Tabs defaultActiveKey="1">
                <Tabs.TabPane tab="Vue Générale" key="1">
                    <Overview/>
                </Tabs.TabPane>
                {/* <Tabs.TabPane tab="Dispatching" key="2">
                    <Dispatching/>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Statistiques" key="3">
                    <Historisation/>
                </Tabs.TabPane> */}
                <Tabs.TabPane tab="Factures" key="2">
                    <p>Contenu de Factures --- EN COURS DE DEVELOPPEMENT</p>
                </Tabs.TabPane>
            </Tabs>
        </SinglePageLayout>
    );
};

export default GestionDesAttestations;
